export const ALEXA_LINKING_ENABLED = 'alexaSkill.accountLinking.enabled';
export const PARTNER_USERNAME = 'partner.username';
export const PARTNER_USERNAME_EXTERNAL_DEMO = 'partner.username.externalDemo';
